import { IocSelectorService } from './../../_shared/components/ioc-selector/ioc-selector.service';
import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { IPlayerCourtTimeLog, Match } from '../../_shared/models/match.model';
import { TranslateService } from '@ngx-translate/core';

interface StartMatch {
    matchId: string;
    matchActive: boolean;
}

@Injectable({ providedIn: 'root' })

export class StartMatchService {
    private startMatch$ = new Subject<StartMatch>();
    private iocSelectorService = inject(IocSelectorService);
     private translateService = inject(TranslateService);

    constructor(
        private httpClient: HttpClient,
    ) { }

    // START MATCH
    startMatch(matchId, scheduledItemObj, sets, notification, score, playerCourtTimeLog) {
        return this.httpClient.put<any>('api_endpoint' + '/match/' + matchId + '/start-match', { scheduledItemObj, sets, score, notification, playerCourtTimeLog });
    }

    publishStartMatch(matchId: string, matchActive: boolean) {
        this.startMatch$.next({ matchId, matchActive });
    }

    subscribeStartMatch(): Observable<StartMatch> {
        return this.startMatch$.asObservable();
    }

    async getServerTrackingMode(match: Match) {
        const iocSelectorOptions: {label: string, value: any }[] = [];

        if (match.matchType === 'S' ||
            (match.sides[0].players[0].participant && match.sides[1].players[0].participant)) {
                iocSelectorOptions.push({
                label: this.translateService.instant('Individual'),
                value: 'individual'
            });
        }

        if (match.matchType === 'D') {
            iocSelectorOptions.push({
                label: this.translateService.instant('Team'),
                value: 'side'
            });
        }

        iocSelectorOptions.push({
            label: this.translateService.instant('Dont track serves'),
            value: 'none'
        });

        const title = this.translateService.instant('Server tracking mode');
        const showCancelButton = true;

        const data = await this.iocSelectorService.openPopover(title, iocSelectorOptions, showCancelButton);

        return data;
    }

    //: { sideNumber: number, players: { playerNumber: number, _id: string, participant: any }[], _id: string }[]
    convertToPlayerCourtTimeLogFormat(
        sides,
        performedBy: string | undefined
    ): { side1: IPlayerCourtTimeLog[]; side2: IPlayerCourtTimeLog[] } {
        const currentDate = new Date(); // for `inTime`
        const playerCourtTimeLogs = {
            side1: [] as IPlayerCourtTimeLog[],
            side2: [] as IPlayerCourtTimeLog[]
        };
        sides.forEach(side => {
            side.players.forEach(playerObj => {
                const playerLog: IPlayerCourtTimeLog = {
                    player: playerObj.participant?._id,
                    sideNumber: side.sideNumber,
                    inTime: currentDate,
                    performedBy: performedBy,
                    isReverted: false,
                    playerNumber: playerObj?.playerNumber,
                    outTime: null,
                    substitutedBy: null,
                    substitutedAt: null,
                    setNumber: 1,
                    inPointNumber: 1,
                    outSetNumber: null,
                };
                if (side.sideNumber === 1) {
                    playerCourtTimeLogs.side1.push(playerLog);
                } else if (side.sideNumber === 2) {
                    playerCourtTimeLogs.side2.push(playerLog);
                }
            });
        });
        return playerCourtTimeLogs;
    }

}
